var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "integralUser seller-style" }, [
    _c("h2", { staticClass: "f18 fb normal gray_2" }, [
      _vm._v("积分管理-用户积分")
    ]),
    _c("div", { staticClass: "box30" }),
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "flex align_center" },
          [
            _c("div", { staticClass: "lable" }, [_vm._v("客户：")]),
            _c("el-input", {
              staticClass: "w240 mar20_r",
              attrs: { placeholder: "请输入客户名称或联系电话" },
              model: {
                value: _vm.selVal,
                callback: function($$v) {
                  _vm.selVal = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "selVal"
              }
            }),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.getPointsDtl } },
              [_vm._v("查询")]
            )
          ],
          1
        ),
        _c("div", { staticClass: "box30" }),
        _c(
          "el-table",
          {
            attrs: { border: "", data: _vm.list, "row-class-name": "pointer" }
          },
          [
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "name",
                label: "客户名称",
                "min-width": "15%"
              }
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "phone",
                label: "联系电话",
                "min-width": "15%"
              }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "grantPoints",
                label: "积分总数",
                "min-width": "15%"
              }
            }),
            _c("el-table-column", {
              attrs: { label: "操作", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "blue",
                          on: {
                            click: function($event) {
                              return _vm.toRecordDetail(scope.row)
                            }
                          }
                        },
                        [_vm._v("查看详情")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }